import { useState, useEffect, useCallback } from 'react';
import { Tool } from '@/types/database';

const STORAGE_KEY = 'recentlyViewedTools';
const MAX_ITEMS = 6;

interface StoredTool {
  id: string;
  slug: string;
  name: string;
  logo_url: string | null;
  short_description: string;
  pricing: string;
  viewedAt: number;
}

export function useRecentlyViewed() {
  const [recentTools, setRecentTools] = useState<StoredTool[]>([]);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        setRecentTools(JSON.parse(stored));
      } catch {
        setRecentTools([]);
      }
    }
  }, []);

  const addTool = useCallback((tool: Tool) => {
    setRecentTools(prev => {
      // Remove if already exists
      const filtered = prev.filter(t => t.id !== tool.id);
      
      // Add to beginning
      const newTool: StoredTool = {
        id: tool.id,
        slug: tool.slug,
        name: tool.name,
        logo_url: tool.logo_url,
        short_description: tool.short_description,
        pricing: tool.pricing,
        viewedAt: Date.now()
      };
      
      const updated = [newTool, ...filtered].slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const clearHistory = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    setRecentTools([]);
  }, []);

  return { recentTools, addTool, clearHistory };
}
